module.exports = __webpack_public_path__ + "static/about-us-sinead-video-screenshot@2x-86cbaa25c91f710fbf02b24ff9a827bd.jpg";